<div class='dashboard-card-wrapper mt-5 mx-auto'>
  <ip-shared-dashboard-card icon='pi-file-edit' label='Șabloane de rapoarte instantanee'
                            [routerLink]='[AppPath.reporting, AppPath.snapshotReportTemplate]'
                            [userAuthorities]='userAuthorities'
                            [requiredAuthorities]='[Authorities.ROLE_ADMIN, Authorities.ROLE_TECH_ADMIN]'>
  </ip-shared-dashboard-card>

  <ip-shared-dashboard-card icon='pi-play' label='Rapoarte instantanee'
                            [routerLink]='[AppPath.reporting, AppPath.snapshotReport]'
                            [userAuthorities]='userAuthorities'
                            [requiredAuthorities]='[Authorities.ROLE_ADMIN, Authorities.ROLE_TECH_ADMIN, Authorities.ROLE_HR_ADMIN, Authorities.ROLE_HR]'>
  </ip-shared-dashboard-card>
</div>
